var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adminPage"},[_c('h1',[_vm._v(_vm._s(_vm.$t('admin.title')))]),_c('Authenticated',[_c('AdminOnly',[_c('admin-menu'),_c('div',{staticClass:"split"},[_c('restaurant-list'),_c('new-restaurant')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }